import { Link } from "react-router-dom";
import { useCurrentUser } from "@/components/AuthProvider";
import { useCenterContext } from "@/contexts/CenterContext";

export function DashboardPage() {
  const user = useCurrentUser();
  const { currentCenter } = useCenterContext();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">대시보드</h1>
        <p className="text-gray-600">안녕하세요, {user.name}님</p>
        {currentCenter && <p className="text-sm text-gray-500">현재 센터: {currentCenter.name}</p>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* 센터 관리 카드 */}
        <Link
          to={currentCenter ? `/centers/${currentCenter.centerId}` : "/centers"}
          className="block p-6 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
        >
          <h3 className="text-lg font-semibold text-gray-900">센터 관리</h3>
          <p className="mt-2 text-sm text-gray-600">
            센터 상세 정보 및 Studiomate 연동을 관리합니다.
          </p>
          <span className="mt-4 inline-block text-blue-600 text-sm font-medium">바로가기 →</span>
        </Link>

        {/* 강사 관리 카드 */}
        <div className="p-6 bg-white rounded-lg shadow opacity-50">
          <h3 className="text-lg font-semibold text-gray-900">강사 관리</h3>
          <p className="mt-2 text-sm text-gray-600">강사 목록 조회 및 관리 (준비 중)</p>
        </div>

        {/* 정산 관리 카드 */}
        <Link
          to={currentCenter ? `/centers/${currentCenter.centerId}/settlements` : "#"}
          className="block p-6 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
        >
          <h3 className="text-lg font-semibold text-gray-900">정산 관리</h3>
          <p className="mt-2 text-sm text-gray-600">강사별 정산 현황 조회</p>
          <span className="mt-4 inline-block text-blue-600 text-sm font-medium">바로가기 →</span>
        </Link>
      </div>
    </div>
  );
}
